import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export function PublicLayout({ children }) {
  return (
    <div className="flex min-h-screen flex-col bg-kys-cream">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
